import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { scrollToTarget } from "@/components/SmoothScroll";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Formations", href: "#formations" },
  { label: "Tarifs", href: "#tarifs" },
  { label: "GRH & PAIE", href: "#boussole" },
  { label: "À propos", href: "#apropos" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  const go = (href) => (e) => {
    e.preventDefault();
    setOpen(false);
    setTimeout(() => scrollToTarget(href), open ? 250 : 0);
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-korban-navy/85 backdrop-blur-xl">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-3.5">
        <a href="/" className="flex items-center gap-3" data-testid="header-logo-link">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white p-1 shadow-md">
            <img src="/logo_korban_consulting.png" alt="KORBAN CONSULTING" className="h-full w-full object-contain" />
          </span>
          <span className="text-sm font-bold uppercase tracking-[0.14em] text-white sm:text-base">
            Korban <span className="text-korban-gold">Consulting</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={go(l.href)}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="rounded-md px-3.5 py-2 text-[0.85rem] font-semibold text-slate-200 transition-colors hover:bg-white/10 hover:text-korban-gold"
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/connexion"
            data-testid="espace-personnel-login-button"
            className="ml-2 inline-flex items-center gap-1.5 rounded-md border-2 border-korban-gold px-4 py-2 text-[0.85rem] font-bold text-korban-gold transition-all hover:bg-korban-gold hover:text-korban-navy"
          >
            Espace personnel <ArrowUpRight size={15} />
          </Link>
        </nav>

        <button
          className="rounded-md border border-white/20 p-2 text-white lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          data-testid="mobile-menu-button"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.25 }}
            className="overflow-hidden border-t border-white/10 bg-korban-navy/95 backdrop-blur-xl lg:hidden"
          >
            <div className="flex flex-col gap-1 px-5 py-4">
              {LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={go(l.href)}
                  className="rounded-lg px-3 py-3 font-display text-lg text-white transition-colors hover:bg-white/10 hover:text-korban-gold"
                >
                  {l.label}
                </a>
              ))}
              <Link
                to="/connexion"
                data-testid="espace-personnel-login-button-mobile"
                className="mt-2 inline-flex items-center justify-center gap-1.5 rounded-lg bg-korban-gold px-4 py-3 font-bold text-korban-navy"
              >
                Espace personnel <ArrowUpRight size={16} />
              </Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
